/**
 * 共通関数
 *
 * @author hayakawa 2025.04.22
 */

/**
 * 現在時刻取得(YYYY-mm-dd HH:ii:ss)
 *
 * @return {string}
 * @author hayakawa 2023.10.20
 */
export const getNow = () => {
    const d = new Date(),
        year = d.getFullYear(),
        month = d.getMonth() + 1,
        day = d.getDate(),
        hour = d.getHours(),
        minute = d.getMinutes(),
        second = d.getSeconds(),
        now = year + '-' +
        ('0' + month).slice(-2) + '-' +
        ('0' + day).slice(-2) + ' ' +
        ('0' + hour).slice(-2) + ':' +
        ('0' + minute).slice(-2) + ':' +
        ('0' + second).slice(-2);

    return now;
}

/**
 * 現在日付取得(YYYY/mm/dd)
 *
 * @return {string}
 * @author hayakawa 2025.04.22
 */
export const getNowDate = () => {
    const d = new Date(),
        year = d.getFullYear(),
        month = d.getMonth() + 1,
        day = d.getDate(),
        hour = d.getHours(),
        minute = d.getMinutes(),
        second = d.getSeconds(),
        now = year + '/' +
        ('0' + month).slice(-2) + '/' +
        ('0' + day).slice(-2);

    return now;
}

/**
 * 現在時刻に分を加算して取得(YYYY-mm-dd HH:ii:ss)
 *
 * @param {number} add_minute
 * @return {string}
 * @author hayakawa 2023.10.20
 */
export const getAddNow = (add_minute = 0) => {
    const d = new Date();
    d.setMinutes(d.getMinutes() + add_minute);

    const year = d.getFullYear(),
        month = d.getMonth() + 1,
        day = d.getDate(),
        hour = d.getHours(),
        minute = d.getMinutes(),
        second = d.getSeconds(),
        add_now = year + '-' +
        ('0' + month).slice(-2) + '-' +
        ('0' + day).slice(-2) + ' ' +
        ('0' + hour).slice(-2) + ':' +
        ('0' + minute).slice(-2) + ':' +
        ('0' + second).slice(-2);

    return add_now;
}

/**
 * バリデーションエラーを表示する
 *
 * @param {array} errors
 * @param {object} $form
 * @param {object} $modal
 * @return {void}
 * @author hayakawa 2023.11.15
 */
export const showValidationErrors = (errors, $form, $modal) => {
    let $ul = `<ul>\n`;
    $.each(errors, function(key, value) {
        const id = $form.find(`[name="${key}"]`).attr('id');

        $form.find(`[name="${key}"]`).addClass('is-invalid');
        $form.find(`[name="${key}"]`).next().text(value);

        if (id === undefined) {
            $ul += `<li>${value}</li>\n`;
        } else {
            $ul += `<li><a href="#${id}" class="alert-link">${value}</a></li>\n`;
        }
    })
    $ul += `</ul>\n`;
    $modal.find('.exec-result-message').empty().append($($ul).prop('outerHTML')).show();
}
